module.exports = __webpack_public_path__ + "img/unsupervised.8db1c0e5.png";